module.exports = __webpack_public_path__ + "img/activity-image.60d05a25.png";